<template>
  <div class="content-wrapper selection-list">
    <div class="d-flex full-height justify-content-center">
      <div class="center">
        <div class="mt-5 mb-4">
          <div class="uppercase small-text pb-4">SELECT A PASSONI TO CONFIGURE</div>
          <p class="sm-content general-content">
            Select one of the 4 Passoni Made-to-Measure models and begin your
            configuration process. If you would like assistance selecting the right base
            model, simply complete our short questionnaire, and we will recommend the
            right one.
          </p>
          <button class="btn btn-outline-primary mt-4" v-on:click="$emit('go-back')">
            Go back to questionnaire
          </button>
        </div>
        <div class="section-filters my-5">
          <div class="xs-text uppercase mb-3">Filter</div>
          <div class="filter-wrapper">
            <div class="filter">
              <div class="xs-text uppercase">use</div>
              <ul>
                <li
                  v-for="filter in this.filters.use"
                  v-bind:key="filter.name"
                  @click="toggleFilter('use', filter.value)"
                  :class="{
                    active: activeFilters['use'].includes(filter.value),
                  }"
                >
                  {{ filter.name }}
                </li>
              </ul>
            </div>
            <div class="filter">
              <div class="xs-text uppercase">material</div>
              <ul>
                <li
                  v-for="filter in this.filters.material"
                  v-bind:key="filter.name"
                  @click="toggleFilter('material', filter.value)"
                  :class="{
                    active: activeFilters['material'].includes(filter.value),
                  }"
                >
                  {{ filter.name }}
                </li>
              </ul>
            </div>
            <div class="filter">
              <div class="xs-text uppercase">brakes</div>
              <ul>
                <li
                  v-for="filter in this.filters.brakes"
                  v-bind:key="filter.name"
                  @click="toggleFilter('brakes', filter.value)"
                  :class="{
                    active: activeFilters['brakes'].includes(filter.value),
                  }"
                >
                  {{ filter.name }}
                </li>
              </ul>
            </div>
            <div class="filter">
              <a
                class="uppercase xs-text"
                style="color: #555"
                href="#"
                @click="resetFilters()"
                >Clean filters</a
              >
            </div>
          </div>
        </div>
        <div class="bikes-list xl-content mt-4">
          <div v-if="bikeCollection?.length == 0">
            No results found, please reload the page
          </div>
          <div
            class="bike"
            v-for="bike in bikeCollection"
            v-bind:key="bike.id"
            v-on:click="selectBike(bike)"
          >
            <img :src="'/storage/' + bike.small_image" />
            {{ bike.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const api = axios.create({
  auth: {
    username: "pixell",
    password: "pixelldemo",
  },
});

export default {
  name: "selection-list",
  data() {
    return {
      bikeCollection: this.bikes,
      activeFilters: {
        use: [],
        material: [],
        brakes: [],
      },
      filters: {
        use: [
          {
            name: "Road",
            value: "2",
          },
          // {
          //   name: "Urban",
          //   value: "1",
          // },
          {
            name: "Off-Road",
            value: "3",
          },
        ],
        material: [
          {
            name: "Carbo-Titanium",
            value: "7",
          },
          {
            name: "Stainless steel",
            value: "6",
          },
          // {
          //   name: "Steel",
          //   value: "2",
          // },
          {
            name: "Titanium",
            value: "4",
          },
        ],
        brakes: [
          {
            name: "Rim",
            value: "1",
          },
          {
            name: "Disk",
            value: "2",
          },
        ],
      },
    };
  },
  watch: {},
  props: ["bikes"],
  mounted() {
    if (this.bikes !== undefined && this.bikes.length == 0) {
      let p = this;
      setTimeout(function () {
        p.filterCollection();
      }, 1000);
    }
  },
  methods: {
    selectBike: function (bike) {
      this.$emit("select-bike", bike);
    },
    toggleFilter: function (type, id) {
      for (const [typeName, activeFilter] of Object.entries(this.activeFilters)) {
        if (type == typeName) {
          if (this.activeFilters[typeName].includes(id)) {
            let ret = [];
            for (let i = 0; i < activeFilter.length; i++) {
              if (this.activeFilters[typeName][i] != id) {
                ret.push(activeFilter[i]);
              }
            }
            this.activeFilters[typeName] = ret;
          } else {
            this.activeFilters[typeName].push(id);
          }
        }
      }
      this.filterCollection();
    },
    filterCollection: function () {
      let collection = this.bikes;

      if (this.activeFilters["use"].length) {
        collection = collection.filter((e) => {
          if (Object.values(this.activeFilters["use"]).includes(e.use_id.toString())) {
            return e;
          }
        });
      }
      if (this.activeFilters["material"].length) {
        collection = collection.filter((e) => {
          if (
            Object.values(this.activeFilters["material"]).includes(
              e.material_id.toString()
            )
          ) {
            return e;
          }
        });
      }
      if (this.activeFilters["brakes"].length) {
        collection = collection.filter((e) => {
          if (
            Object.values(this.activeFilters["brakes"]).includes(e.brake_id.toString())
          ) {
            return e;
          }
        });
      }

      this.bikeCollection = collection;
    },
    objectContains: function (object, element) {
      for (const [key, obj] in Object.entries(object)) {
        if (obj == element) return true;
      }
      return false;
    },
    emptyFilters: function () {
      return (
        this.activeFilters["use"].length == 0 &&
        this.activeFilters["material"].length == 0 &&
        this.activeFilters["brakes"].length == 0
      );
    },
    resetFilters: function () {
      this.activeFilters = {
        use: [],
        material: [],
        brakes: [],
      };
      this.filterCollection();
      this.bikeCollection = this.bikes;
    },
  },
};
</script>

<style lang="scss" scoped>
.selection-list {
  .bike {
    cursor: pointer;
  }

  li {
    cursor: pointer;

    &.active {
      text-decoration: underline;
    }
  }
}
</style>
